import { Typography, Grid, Card, useTheme, Avatar } from "@mui/material";
import { gridSpacing } from "constant";
// assets
import { useState } from "react";
import {
  SocialCommitmentTypeHour,
  SocialCommitmentTypeSpend,
  socialCommitmentTypeToString,
} from "@interfaces/commitment";

interface DirectoryCardProps {
  name: string;
  logo: string;
  descriptions: string;
  benefits: SocialCommitmentTypeSpend | SocialCommitmentTypeHour;
  url: string;
}
export const DirectoryCard = ({
  name,
  logo,
  descriptions,
  benefits,
  url,
}: DirectoryCardProps) => {
  const theme = useTheme();

  const about = descriptions;
  const contact = url;

  return (
    <Card
      sx={{
        p: 2,
        background:
          theme.palette.mode === "dark"
            ? theme.palette.dark.main
            : theme.palette.grey[50],
        border:
          theme.palette.mode === "dark"
            ? "1px solid transparent"
            : `1px solid${theme.palette.grey[100]}`,
        "&:hover": {
          borderColor: theme.palette.primary.main,
        },
      }}
    >
      <Grid container spacing={gridSpacing}>
        <Grid item xs={6}>
          <Grid container spacing={gridSpacing}>
            <Grid item xs zeroMinWidth>
              <Avatar alt={name} src={logo} />
            </Grid>
            {/* <Grid item>
              <IconButton
                size="small"
                sx={{ mt: -0.75, mr: -0.75 }}
                onClick={handleClick}
                aria-label="more-options"
              >
                <MoreHorizOutlinedIcon
                  fontSize="small"
                  color="inherit"
                  aria-controls="menu-friend-card"
                  aria-haspopup="true"
                  sx={{ opacity: 0.6 }}
                />
              </IconButton>
            </Grid> */}
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h3" component="div">
            {name}
          </Typography>
          <Typography variant="caption">{descriptions}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography
            variant="subtitle2"
            sx={{ color: theme.palette.grey[700] }}
          >
            {about}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="caption">Benefits</Typography>
          <Typography variant="h6">
            {socialCommitmentTypeToString(benefits)}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={gridSpacing}>
            <Grid item xs={6}>
              <Typography variant="caption">Website</Typography>
              <Typography variant="h6">
                <a href={contact} target="_blank">
                  {contact}
                </a>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        {/* <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Button
                variant="outlined"
                fullWidth
                startIcon={<ChatBubbleTwoToneIcon />}
              >
                Contact
              </Button>
            </Grid>
          </Grid>
        </Grid> */}
      </Grid>
    </Card>
  );
};
